import { useState, useEffect } from "react";
import { useAction, useQuery } from "convex/react"
import { api } from "../convex/_generated/api.js"
import { DataGrid } from "@mui/x-data-grid"
import { useParams } from 'react-router-dom';

const ApplicantList = () =>{

    const { id } = useParams();
    const [resumeUrls, setResumeUrls] = useState({});
    // eslint-disable-next-line no-unused-vars
    const applicants = useQuery(api.applicants.getApplicantsByReferralId,{ id : id })

  const ur = useAction(api.applicants.getResumeUrl);

  useEffect(() => {
    const fetchResumeUrls = async () => {
      if (!applicants) return; // Check if applicants is defined

      const urls = {};
      let index = 0;

      await Promise.all(
        applicants.map(async (applicant) => {
          try {
            const resumeUrl = await ur({ storageId: applicant.resume });
            urls[index++] = resumeUrl;
          } catch (error) {
            console.error(`Error fetching resume URL for applicant ${applicant.id}:`, error);
            urls[applicant.id] = null;
          }
        })
      );

      setResumeUrls(urls);
    };

    fetchResumeUrls();
  }, [applicants, ur]);

  if (applicants === null) {
    // Render a loading state or return null
    return <p>Loading...</p>;
  }
    
    const columns = [
        { field: 'id', headerName: 'ID', width: 100 },
        { field: 'name', headerName: 'Name', width: 200 },
        { field: 'email', headerName: 'Email', width: 200 },
        {
          field: 'resume',
          headerName: 'Resume',
          width: 250,
          renderCell: (params) => {
           
            return(
            <a
              href={resumeUrls[params.row.id]}
              target="_blank"
              rel="noopener noreferrer"
            >
              View Resume
            </a>
          )}
        },
        { field: 'JobId', headerName: 'JobId', width: 200 },
        { field: 'feedback', headerName: 'feedback', width: 200 }
      ]
    
      const rows = applicants ? applicants.map((applicant, index) => ({
        id: index.toString(), 
        name: applicant.name,
        email: applicant.email,
        resume: applicant.resume,
        skills: applicant.skills,
        JobId: applicant.jobId,
        Feedback: applicant.feedback
    
      })) : null
    
      return (
        <div>
          <div style={{ height: 400, width: '100%' }}>
            {
            applicants && <DataGrid
              rows={rows}
              columns={columns}
              pageSize={5}
              rowsPerPageOptions={[5, 10, 20]}
            />
            }
          </div>
        </div>
      )
}
export default ApplicantList